import { submitsTabUIInitialState } from "./uiLandingPageSubmitsTabState";
import { makeSubmitsTabUIActions } from "./uiLandingPageSubmitsTabActions";

export const createSubmitsTabUISlice = (set, get) => ({
  submitsTabUI: submitsTabUIInitialState,
  submitsTabUIActions: Object.freeze(makeSubmitsTabUIActions(set, get)),
});
